import(/* webpackMode: "eager" */ "/private/tmp/statura-proddeploy-clL4Bu/apps/web/src/app/error.tsx");
